import { Component, OnInit, Input } from '@angular/core';
import { DashboardTemplateImageTextImage, DashboardCta } from '@bluecrew/crew-member-backend-angular-client';
import { CtaHandlerService } from 'src/app/services/cta-handler.service';

@Component({
  selector: 'app-img-text-img',
  templateUrl: './img-text-img.component.html',
  styleUrls: ['./img-text-img.component.scss'],
})
export class ImgTextImgComponent implements OnInit {

  @Input()
  get feedItem(): DashboardTemplateImageTextImage { return this._feedItem; }
  set feedItem(feedItem: DashboardTemplateImageTextImage) {
    this.headerText = feedItem.headerText;
    this.headerImage = feedItem.headerImage;
    this.bodyText = feedItem.bodyText;
    this.bodyImage = feedItem.bodyImage;
    this.ctas = feedItem.ctas;
    this._feedItem = feedItem;
  }
  private _feedItem: DashboardTemplateImageTextImage;

  @Input() headerText: string;
  @Input() headerImage: string;
  @Input() bodyText: string;
  @Input() bodyImage: string;
  @Input() ctas: Array<DashboardCta>;
  
  constructor(private ctaHandler: CtaHandlerService) { }

  ngOnInit() {}

  onImageClick() {
    if (this.ctas && this.ctas.length == 1) {
      this.ctaHandler.handle(this.ctas[0]);
    }
  }

  onClick(cta: DashboardCta) {
    if (cta) {
      this.ctaHandler.handle(cta);
    }
  }
}
